import { groupOfColor, colorsOfGroup } from "./colors.js";

const data = {
  "50": {
    "15x20": { matte: 7.7 },
    "20x25": { matte: 7.7 },
    "25x30": { matte: 8.8 },
    "25x35": { matte: 16.5 },
    "30x35": { matte: 15.4 },
    "30x40": { matte: 15.4 },
  },
  "60": {
    "15x20": { transparent: 7.7 },
    "20x25": { transparent: 12.1 },
    "25x35": { transparent: 16.5 },
    "30x35": { transparent: 17.6 },
    "30x40": { transparent: 17.6 },
  },
};

export function packPrice(density, size, color) {
  const group = groupOfColor(color);
  return data?.[density]?.[size]?.[group];
}

export function densityScale() {
  return Object.keys(data);
}

export function sizeScale(density) {
  return Object.keys(data[density] ?? {});
}

export function defaultSize(density) {
  return sizeScale(density)[0];
}

export function colorsScale(density, size) {
  const groups = Object.keys(data?.[density]?.[size] ?? {});
  return groups.map((g) => colorsOfGroup(g)).flat();
}

export function defaultColor(density, size, prevColorName) {
  const scale = colorsScale(density, size);
  return scale.find((c) => c.name === prevColorName) || scale[0];
}
